import { RefObject, useEffect, useRef } from 'react'

export const useScrollIntoView = <T extends HTMLElement>(arg?: boolean | ScrollIntoViewOptions): RefObject<T | null> => {
  const navActiveItemRef = useRef<T>(null)

  useEffect(() => {
    if (!navActiveItemRef.current || !navActiveItemRef.current.scrollIntoView) { return }
    navActiveItemRef.current.scrollIntoView(arg ?? { behavior: 'auto', block: 'nearest', inline: 'nearest' }) 
  }, [navActiveItemRef.current])
    
  return navActiveItemRef
}